import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartIcicle } from './useGetChartIcicle'
import { ChartIcicleContent } from './ChartIcicleContent'

export const ChartIcicleComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartIcicle(id, tileFilterSelections)

  return (
    <ChartIcicleContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartIcicleComponentLoading() {
  return 'Loading...'
}
